import * as React from 'react';

import { cn } from '@/lib/cn';

export type InputProps = React.ComponentProps<'textarea'>;

function TextArea({ className, ref, ...props }: InputProps) {
  return (
    <textarea
      className={cn(
        'flex w-full rounded-input border border-input bg-surface px-4 py-3 text-sm file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground/70 focus-within:border-ring focus-within:ring-[3px] focus-within:ring-ring/50 focus-visible:outline-hidden disabled:cursor-not-allowed disabled:opacity-50',
        className
      )}
      ref={ref}
      {...props}
    ></textarea>
  );
}

export { TextArea };
